import {Link} from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function MasterMenu(){

const MenuCard = ({link,title,icon,color}) => (

<div className="col-xl-3 col-lg-4 col-md-6 mb-4">
<Link to={link} className="menu-link">

<div className="menu-card" style={{borderTop:`4px solid ${color}`}}>

<div className="menu-icon" style={{color:color}}>
<FontAwesomeIcon icon={icon} size="2x"/>
</div>

<p className="menu-title">{title}</p>

</div>

</Link>
</div>

)

return(

<section className="container-fluid mt-4">

<h5 className="menu-section-title">General Master Setting</h5>

<div className="row">

<MenuCard link="/user-register" title="User Master" icon="fa-solid fa-user" color="#0d6efd"/>
<MenuCard link="/change-password" title="Change Password" icon="fa-solid fa-key" color="#dc3545"/>
<MenuCard link="/add-department" title="Add Department" icon="fa-solid fa-building" color="#20c997"/>
<MenuCard link="/speech" title="Speech" icon="fa-solid fa-microphone" color="#fd7e14"/>

</div>


<h5 className="menu-section-title">Patient Details</h5>

<div className="row">

<MenuCard link="/add-patient" title="New Patient Registration" icon="fa-solid fa-user-plus" color="#20c997"/>

</div>


</section>

)

}

export default MasterMenu;